/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import AssetPermissions from '../model/AssetPermissions';
import AvailablePrincipals from '../model/AvailablePrincipals';
import CallerPermissions from '../model/CallerPermissions';
import PermissionGrant from '../model/PermissionGrant';

/**
* Permissions service.
* @module api/PermissionsApi
* @version 1.0.0
*/
export default class PermissionsApi {

    /**
    * Constructs a new PermissionsApi. 
    * @alias module:api/PermissionsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the getAssetPermissions operation.
     * @callback module:api/PermissionsApi~getAssetPermissionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AssetPermissions} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} assetId 
     * @param {module:api/PermissionsApi~getAssetPermissionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AssetPermissions}
     */
    getAssetPermissions(assetId, callback) {
      let postBody = null;
      // verify the required parameter 'assetId' is set
      if (assetId === undefined || assetId === null) {
        throw new Error("Missing the required parameter 'assetId' when calling getAssetPermissions");
      }

      let pathParams = {
        'assetId': assetId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AssetPermissions;
      return this.apiClient.callApi(
        '/asset/{assetId}/permissions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getAvailablePrincipals operation.
     * @callback module:api/PermissionsApi~getAvailablePrincipalsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AvailablePrincipals} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/PermissionsApi~getAvailablePrincipalsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AvailablePrincipals}
     */
    getAvailablePrincipals(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AvailablePrincipals;
      return this.apiClient.callApi(
        '/permissions/principals', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCallerPermissions operation.
     * @callback module:api/PermissionsApi~getCallerPermissionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CallerPermissions} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/PermissionsApi~getCallerPermissionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CallerPermissions}
     */
    getCallerPermissions(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = CallerPermissions;
      return this.apiClient.callApi(
        '/permissions/me', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the setAssetPermissions operation.
     * @callback module:api/PermissionsApi~setAssetPermissionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AssetPermissions} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} assetId 
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/PermissionGrant>} [permissionGrant] 
     * @param {module:api/PermissionsApi~setAssetPermissionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AssetPermissions}
     */
    setAssetPermissions(assetId, opts, callback) {
      opts = opts || {};
      let postBody = opts['permissionGrant'];
      // verify the required parameter 'assetId' is set
      if (assetId === undefined || assetId === null) {
        throw new Error("Missing the required parameter 'assetId' when calling setAssetPermissions");
      }

      let pathParams = {
        'assetId': assetId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['bearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = AssetPermissions;
      return this.apiClient.callApi(
        '/asset/{assetId}/permissions', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
